import { useCallback, type MutableRefObject } from 'react'

export interface MirroredChatMessage {
  role: 'user' | 'assistant'
  content: string
}

type HasMessagesSink = (hasMessages: boolean) => void
type MessagesSink = (messages: MirroredChatMessage[]) => void

export function useChatMessageChangeHandler(
  setLocalHasMessages: HasMessagesSink,
  onHasMessagesChange: HasMessagesSink,
  setLocalMessages: MessagesSink,
  onMessagesMirror: MessagesSink,
) {
  return useCallback((messages: MirroredChatMessage[]) => {
    const hasMessages = messages.length > 0
    setLocalHasMessages(hasMessages)
    onHasMessagesChange(hasMessages)

    const mirror = messages.map(message => ({role: message.role, content: message.content}))
    setLocalMessages(mirror)
    onMessagesMirror(mirror)
  }, [onHasMessagesChange, onMessagesMirror, setLocalHasMessages, setLocalMessages])
}

export function useMessagesMirrorRef(target: MutableRefObject<MirroredChatMessage[]>) {
  return useCallback((messages: MirroredChatMessage[]) => {
    target.current = messages
  }, [target])
}
